import React from "react"
import Form from "react-bootstrap/Form"
import Icon from "../../Utils/Icon"
import { PUBLISHED, UNPUBLISHED } from "./PublishHandler"

import styles from "./Styles/PublishSwitch.module.scss"
import "../../../styles/full_height.scss"

const PublishSwitch: React.FC<{
  published: boolean
  onChange: any
}> = ({ published, onChange }) => {
  return (
    <div className={styles.publish}>
      <Icon
        type="feather"
        name={published ? "eye" : "eye-off"}
        attr={{ width: 16, height: 16 }}
      />
      <Form>
        <Form.Group controlId="publishedControl" className={styles.formGroup}>
          <Form.Control
            as="select"
            size="sm"
            custom
            value={published ? PUBLISHED : UNPUBLISHED}
            onChange={onChange}
          >
            <option value={PUBLISHED}>公開</option>
            <option value={UNPUBLISHED}>非公開</option>
          </Form.Control>
        </Form.Group>
      </Form>
    </div>
  )
}

export default PublishSwitch
